<div class="container">
  <div [ngStyle]="getTitleStyles()" class="title">{{ data.title }}</div>

  <img *ngIf="data.imageSrc" [src]="data.imageSrc" alt="" />

  <div class="message" *ngIf="data.message">{{ data.message }}</div>

  <div *ngIf="data.expeditorTerms" class="expeditor-terms">
    <ion-checkbox labelPlacement="end" [(ngModel)]="acceptExpeditorTerms">
      <span>Принять</span>
    </ion-checkbox>
    <span
      class="pseudo-link"
      (click)="openExpeditorTerms()"
      (keyup.enter)="openExpeditorTerms()"
      (keydown.space)="openExpeditorTerms()"
      tabindex="0"
      role="link"
    >
      Договор экспедирования
    </span>
  </div>

  <div
    *ngIf="data.exportXLSButton && data.orderData?.id"
    class="button-wrapper"
  >
    <ion-button
      class="secondary large"
      mode="md"
      (click)="exportXLS()"
      [disabled]="loading"
    >
      <ion-icon src="../../../assets/icon/xls-icon.svg"></ion-icon>
      <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
      <span>Скачать РТС в XLS</span>
    </ion-button>
  </div>

  <!-- принять заявку в работу -->
  <ion-button
    *ngIf="data.confirmButton && data.expeditorTerms"
    class="primary large"
    mode="md"
    (click)="confirm()"
    [disabled]="!acceptExpeditorTerms || loading"
  >
    <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
    <span>{{ data.confirmButtonText }}</span>
  </ion-button>

  <ion-button
    *ngIf="data.confirmButton && !data.expeditorTerms"
    [class]="'primary large ' + (data.confirmButtonClass || '')"
    mode="md"
    (click)="confirm()"
    [disabled]="loading"
  >
    <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
    <span>{{ data.confirmButtonText }}</span>
  </ion-button>
  <ion-button
    *ngIf="data.rejectButton"
    class="danger large"
    mode="md"
    (click)="reject()"
    [disabled]="loading"
  >
    <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
    <span>{{ data.rejectButtonText }}</span>
  </ion-button>
  <ion-button
    *ngIf="!data.closeButton"
    class="cancel large"
    mode="md"
    (click)="cancel()"
    [disabled]="loading"
    >Отмена</ion-button
  >
  <ion-button
    *ngIf="data.closeButton"
    class="cancel large"
    mode="md"
    (click)="cancel()"
    [disabled]="loading"
    >Закрыть</ion-button
  >
</div>
